import { DEFAULT_IMAGE_FORMAT, TRANSPARENT_IMAGE_FORMAT } from './platform/default';

export * from './imageFormat.constants';

export { DEFAULT_IMAGE_FORMAT, TRANSPARENT_IMAGE_FORMAT };

// Respects the dimensions given by keeping the ratio of the image.
// So if the requested dimensions do not correspond to the original
// ratio, we crop the image from the center, so the generated image
// is either cut top and bottom or left and right equally
export const IMAGE_FIT_SCALE_CROP = 'scale_crop';

export const IMAGE_FIT_CROP = 'crop';

// Respects the max data dimension while maintaining the ratio of the image)
export const IMAGE_FIT_MAX = 'max';

export const IMAGE_QUALITY = 80;

export const IMAGE_ITEMS_DEFAULT_OPTIONS = {
  image: {
    fit: IMAGE_FIT_SCALE_CROP,
    quality: IMAGE_QUALITY,
    format: DEFAULT_IMAGE_FORMAT,
    interlace: 1,
    blur: 0,
    width: 256,
    height: 256,
  },
  logo: {
    fit: IMAGE_FIT_SCALE_CROP,
    quality: IMAGE_QUALITY,
    format: TRANSPARENT_IMAGE_FORMAT,
    interlace: 1,
  },
};
